export const DISCOUNT_NAME_PREFIX = 'PX: ';
export const DISCOUNT_SOURCE = {
  LOYALTY: 'loyalty',
  OTHER: 'other',
};

export function addDiscountNamePrefix(discountName) {
  return DISCOUNT_NAME_PREFIX + discountName;
}

export function removeDiscountNamePrefix(discountName) {
  if (discountName.startsWith(DISCOUNT_NAME_PREFIX)) {
    return discountName.slice(DISCOUNT_NAME_PREFIX.length);
  }

  return discountName;
}

export function checkIsDiscountForAlternateCard(
  discount,
  processingCardNumber
) {
  return (
    discount?.metadata?.pxCardId !== processingCardNumber &&
    discount?.metadata?.pxCompCardId !== processingCardNumber
  );
}
